import React, { Component } from "react";
import { Grid, Button, Dialog, DialogActions, DialogTitle, Paper, Collapse, Tooltip, TextField } from "@material-ui/core";

import request from "superagent";
import { url_endpoint, url_s3 } from "../../../config";
import authHeader from "../../Utils/AuthHeader";
import ErrorIcon from '@material-ui/icons/Error';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { Link } from "react-router-dom";
import AddIcon from "@material-ui/icons/Add";
import Fab from "@material-ui/core/Fab";
import "./postcast.css";
import LoaderSpinner from "../../../componentes/LoaderSpinner";
import checkLogin from "../../Utils/checkLogin";
import palette from "../../../theme/palette";
import LogoBlogplay from '../../../images/logo_blogplay_color.svg'
import { ExpandLess, ExpandMore } from "@material-ui/icons";

class Postcast extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            showPlayer: false,
            podcastPlaying: {},
            pedidos: [],
            loading: false,
            openDialog: false,
            idCancelar: 0,
            clientName: '',
            clientLogo: '',
            approvedItems: [],
            processItems: [],
            expandingApproved: true,
            expandingInProgress: false,
            expandingRequested: false,
            searchParam: '',
            searchedResults: null,
            searchedApproved: null,
            searchedInProgress: null,
            searchedRequested: null,
        }
        props.setTitulo(`Áudios`);
        this.status = [
            <ErrorIcon style={{ position: "absolute", top: -15, right: -10, color: "#bf9726", fontSize: 45 }} />,
            <CancelIcon style={{ position: "absolute", top: -15, right: -10, color: "#91000a", fontSize: 45 }} />,
            <CheckCircleIcon style={{ position: "absolute", top: -15, right: -10, color: "#00910d", fontSize: 45 }} />
        ];
    }

    async componentDidMount() {
        try {
            await checkLogin(false)
            this.setState({ loading: true });
            const resClient = await request.get(url_endpoint + 'cliente/me/').set(authHeader())
            this.setState({ clientName: resClient.body.nome, clientLogo: `${resClient.body.img_logo.includes('digitalocean') ? resClient.body.img_logo : url_s3 + resClient.body.img_logo}` })
            this.props.setTitulo(`Áudios`)
            const res = await request.get(url_endpoint + "podcast/all").set(authHeader());
            const pedidos = await request.get(url_endpoint + "pedido").set(authHeader());

            let approved = []
            let processing = []

            res.body.forEach(i => {
                if (i.status == 2) {
                    approved.push(i)
                }
                else {
                    processing.push(i)
                }
            })

            this.setState({ loading: false, data: res.body, pedidos: pedidos.body, approvedItems: approved, processItems: processing });
        } catch (e) {
            this.setState({ loading: false });
            // alert(e); 
            console.log(e)
        }
    }
    cancelarRequisicao = async (id) => {
        this.setState({ idCancelar: id, openDialog: true });
    }

    handleClose = () => {
        this.setState({ openDialog: false });
    };

    confirmarCancelamento = async () => {
        try {
            this.setState({ openDialog: false, loading: true });
            await request.delete(url_endpoint + "pedido/" + this.state.idCancelar).set(authHeader());

            const pedidos = this.state.pedidos;


            const index = pedidos.findIndex(i => i.id === this.state.idCancelar);
            pedidos.splice(index, 1);
            this.setState({ pedidos });

        } catch (err) {
            alert(err.response.text);
            console.log(err)
        } finally {
            this.setState({ idCancelar: 0, loading: false });
        }

    }

    buildCard(imageUrl, text, barColor) {
        return <div style={{ display: 'flex', flexDirection: 'column', width: '200px', margin: '10px' }} >
            <img style={{ height: '120px', width: '100%', borderRadius: '15px 15px 0 0', objectFit: 'cover' }} src={imageUrl}></img>
            <Paper style={{ padding: '5px' }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    flexDirection: 'column',
                    rowGap: '15px',
                    height: '100px',
                }}>
                    <Tooltip title={text} placement="top-start" arrow>
                        <p style={{ margin: '11px 5px 0 5px', fontSize: '15px', height: '50px' }}>{text.length > 55 ? `${text.substring(0, 55)}...` : text}</p>
                    </Tooltip>
                    <div style={{ marginBottom: '11px', width: '25%', height: '10px', backgroundColor: barColor, borderRadius: '5px' }}></div>
                </div>
            </Paper>
        </ div>
    }

    async searchAudios() {
        try {
            this.setState({ loading: true })

            const resPodcasts = await request.get(url_endpoint + 'podcast/search/' + this.state.searchParam).set(authHeader())
            const resPedidos = await request.get(url_endpoint + 'pedido/search/' + this.state.searchParam).set(authHeader())

            let approved = []
            let processing = []

            resPodcasts.body.forEach(i => {
                if (i.status == 2) {
                    approved.push(i)
                }
                else {
                    processing.push(i)
                }
            })

            this.setState({ searchedResults: resPodcasts.body, loading: false, searchedApproved: approved, searchedInProgress: processing, searchedRequested: resPedidos.body })
        } catch (e) {
            const msg = e.response.text
        }
    }

    render() {
        return (
            <div style={{
                padding: '20px'
            }}>
                {this.state.loading &&
                    <LoaderSpinner />
                }

                <Dialog open={this.state.openDialog} onClose={this.handleClose} aria-labelledby="draggable-dialog-title">
                    <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                        {"Tem certeza que deseja excluir o pedido?"}
                    </DialogTitle>
                    <DialogActions>
                        <Button autoFocus onClick={this.handleClose} color="primary">
                            {"Não"}
                        </Button>
                        <Button onClick={this.confirmarCancelamento} color="primary">
                            {"Sim"}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Grid container spacing={3}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
                        <TextField
                            onChange={(e) => {
                                this.state.searchParam = e.target.value
                                if (this.state.searchParam == '') {
                                    this.state.searchedResults = null
                                    this.state.searchedApproved = null
                                    this.state.searchedInProgress = null
                                    this.state.searchedRequested = null
                                }
                                this.setState({})
                            }}
                            value={this.state.searchParam}
                            label="Pesquisar áudio"
                            variant='filled'
                            style={{ border: '1px solid lightgrey', borderRadius: '4px', backgroundColor: 'white', boxShadow: '0px 0px 2px grey' }}
                            InputProps={{ disableUnderline: true, style: { backgroundColor: 'white' } }}
                        ></TextField>
                        {this.state.searchParam.length > 0 &&
                            <Button
                                variant="contained"
                                onClick={() => this.searchAudios()}
                                color="primary"
                            >
                                Pesquisar
                            </Button>
                        }
                    </div>
                    <Grid style={{ marginBottom: '5px', marginTop: '10px' }} container spacing={3}>
                        <div style={{ gap: '5px', cursor: "pointer", display: 'flex', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'space-between', width: '100%', marginBottom: '5px' }} onClick={() => { this.setState({ expandingApproved: !this.state.expandingApproved }) }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {
                                    this.state.expandingApproved ?
                                        <ExpandMore fontSize="large"></ExpandMore> :
                                        <ExpandLess fontSize="large"></ExpandLess>
                                }
                                <h2 style={{ marginLeft: 15 }}>
                                    Áudios aprovados
                                </h2>
                            </div>
                            <Link to={"/painel/postcasts/new"}>
                                <Button variant="contained" color="primary" style={{ textTransform: 'none', fontWeight: 'bold' }}>Solicitar Novo Áudio +</Button>
                            </Link>
                        </div>
                    </Grid>
                    <Collapse in={this.state.expandingApproved}>
                        <Grid container spacing={3}>
                            {(this.state.searchedApproved ?? this.state.approvedItems).map((item) => {
                                return (
                                    <Link to={"/painel/postcasts/detail/" + item.id}>
                                        {this.buildCard((item.imagem != null && item.imagem != '') ? (item.imagem.includes('digitalocean') ? item.imagem : `${url_s3}${item.imagem}`) : LogoBlogplay, item.titulo, 'green')}
                                    </Link>
                                )
                            })}
                        </Grid>
                    </Collapse >

                    <Grid style={{ marginBottom: '5px', marginTop: '10px' }} container spacing={3}>
                        <div style={{ marginBottom: '5px', cursor: "pointer", display: 'flex', alignItems: 'center' }} onClick={() => { this.setState({ expandingInProgress: !this.state.expandingInProgress }) }}>
                            {
                                this.state.expandingInProgress ?
                                    <ExpandMore fontSize="large"></ExpandMore> :
                                    <ExpandLess fontSize="large"></ExpandLess>
                            }
                            <h2 style={{ marginLeft: 15 }}>
                                Em andamento
                            </h2>
                        </div>
                    </Grid>
                    <Collapse in={this.state.expandingInProgress}>
                        <Grid container spacing={3}>
                            {(this.state.searchedInProgress ?? this.state.processItems).map((item) => {
                                return (
                                    <Link to={"/painel/postcasts/detail/" + item.id}>
                                        {this.buildCard((item.imagem != null && item.imagem != '') ? (item.imagem.includes('digitalocean') ? item.imagem : `${url_s3}${item.imagem}`) : LogoBlogplay, item.titulo, palette.primary.main)}
                                    </Link>
                                )
                            })}
                        </Grid>
                    </Collapse>
                    <Grid style={{ marginBottom: '5px', marginTop: '10px' }} container spacing={3}>
                        <div style={{ marginBottom: '5px', cursor: "pointer", display: 'flex', alignItems: 'center' }} onClick={() => { this.setState({ expandingRequested: !this.state.expandingRequested }) }}>
                            {
                                this.state.expandingRequested ?
                                    <ExpandMore fontSize="large"></ExpandMore> :
                                    <ExpandLess fontSize="large"></ExpandLess>
                            }
                            <h2 style={{ marginLeft: 15 }}>
                                Solicitados
                            </h2>
                        </div>
                    </Grid>
                    <Collapse in={this.state.expandingRequested}>
                        <Grid container spacing={3}>
                            {(this.state.searchedRequested ?? this.state.pedidos).map((item) => {
                                return (
                                    <div style={{ cursor: 'pointer' }} onClick={_ => this.cancelarRequisicao(item.id)}>
                                        {this.buildCard((item.imagem != null && item.imagem != '') ? (item.imagem.includes('digitalocean') ? item.imagem : `${url_s3}${item.imagem}`) : LogoBlogplay, item.titulo, 'red')}
                                    </div>
                                )
                            })}
                        </Grid>
                    </Collapse>
                </Grid >
            </div >
        )
    }
}
export default Postcast;
